// extracted by mini-css-extract-plugin
export default {"wrapper":"banner_wrapper__ffXeo","message":"banner_message__7FSsD","error":"banner_error__hr3Hf","warning":"banner_warning__dmS+y","success":"banner_success__BA2Pu"};